import styled from "styled-components";

const Container = styled.div`
    padding: ${props => props.mobileScreen ? "80px 0px 10px 0px" : "70px 0px"};
    display: flex;
    justify-content: center;
`;
export { Container };